/* eslint-disable prettier/prettier */
/* eslint-disable */

export const getDragItemRotation = (index: number, arrayLength: number) => {
  if (index === arrayLength - 1) return '0deg';
  if (index % 2 === 0) return '5deg';
  return '-5deg';
};
